export enum OstiariesAspMethod {
  DOMESTIC = 'domestic',
  OVERSEAS = 'overseas',
  BOTH = 'both',
}
